<template>
  <div class="form-sender-container" :class="{ fullscreen: isFullScreen }">
    <div v-if="file" class='file-container' :style="{backgroundColor: chatbotColors.userInput.text, color: chatbotColors.userInput.bg}">
      <span class='icon-file-message'><img :src="icons.file.img"  :alt="icons.file.name" height="15" /></span>
      {{file.name}}
      <span class='delete-file-message' @click="cancelFile()"><img :src="icons.closeSvg.img" :alt="icons.closeSvg.name" height="10" title='Remove the file' /></span>
    </div>
    <form class="sc-user-input" :class="{active: inputActive}">
      <input
        type="text"
        tabIndex="0"
        @focus="setInputActive(true)"
        @blur="setInputActive(false)"
        @keydown="handleKey"
        contentEditable="true"
        :placeholder="placeholder"
        class="sc-user-input--text"
        ref="userInput"
      />

      <div class="sc-user-input--buttons">
        <div v-if="isEditing" class="sc-user-input--button">
          <user-input-button @click.native.prevent="_editFinish" :chatbotColors="chatbotColors">
            <icon-cross />
          </user-input-button>
        </div>
        <div class="sc-user-input--button">
          <user-input-button @click.native.prevent="_editText" v-if="isEditing" :chatbotColors="chatbotColors">
            <icon-ok />
          </user-input-button>
          <user-input-button @click.native.prevent="_submit" v-else :chatbotColors="chatbotColors">
            <icon-send />
          </user-input-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import UserInputButton from '../UserInputButton.vue'
import FileIcon from '../assets/file.svg'
import CloseIconSvg from '../assets/close.svg'
import store from "../store/"
import IconCross from "../components/icons/IconCross.vue";
import IconOk from "../components/icons/IconOk.vue";
import IconSend from "../components/icons/IconSend.vue";
import Inputmask from "inputmask";

export default {
  components: {
    UserInputButton,
    IconCross,
    IconOk,
    IconSend
  },
  props: {
    icons:{
      type: Object,
      required: false,
      default: function () {
        return {
          file:{
            img: FileIcon,
            name: 'default',
          },
          closeSvg:{
            img: CloseIconSvg,
            name: 'default',
          },
        }
      }
    },
    onSubmit: {
      type: Function,
      required: true
    },
    chatbotColors: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      file: null,
      inputActive: false,
      store
    }
  },
  watch: {
    editMessageId (){
      if (store.editMessage != null && store.editMessage != undefined){
        this.focusUserInput();
        this.$refs.userInput.value = store.editMessage.data.text;
      } else {
        this.$refs.userInput.value = '';
      }
    }
  },
  computed: {
    editMessageId() {
      return this.isEditing && store.editMessage.id;
    },
    isEditing() {
      return store.editMessage && store.editMessage.id
    },
    placeholder () {
      return this.$store.state.respostaPlaceholder || 'Insira aqui...';
    },
    respostaMask () {
      return this.$store.state.respostaMask;
    },
    respostaRegex () {
      return this.$store.state.respostaRegex;
    },
    isFullScreen () {
      return this.$store.getters.isFullScreen;
    }
  },
  mounted () {
    const respostaPadrao = this.$store.state.respostaPadrao;

    if (respostaPadrao) {
      this._submitText(respostaPadrao, true);
      return;
    }

    window.EventBus.$once('FOCUS_USER_INPUT', this.focusUserInput);

    Inputmask.remove(this.$refs.userInput);

    if (this.respostaRegex) {
      Inputmask({
        regex: this.respostaRegex,
        showMaskOnHover: false,
        showMaskOnFocus: false,
        onKeyDown: event => {
          setTimeout(() => {
            this.handleKey(event);
          }, 100);
        },
        oncomplete: event => {
          setTimeout(() => {
            this.handleKey(event);
          }, 100);
        },
      }).mask(this.$refs.userInput);
    }

    else if (this.respostaMask) {
      Inputmask({
        mask: this.respostaMask,
        showMaskOnHover: false,
        showMaskOnFocus: false,
        onKeyDown: event => {
          setTimeout(() => {
            this.handleKey(event);
          }, 100);
        },
        oncomplete: event => {
          setTimeout(() => {
            this.handleKey(event);
          }, 100);
        },
      }).mask(this.$refs.userInput);
    }
  },
  methods: {
    cancelFile () {
      this.file = null
    },
    setInputActive (onoff) {
      this.inputActive = onoff
    },
    handleKey (event) {
      const value = this.$refs.userInput?.value;

      if (event.keyCode === 13 && !event.shiftKey) {
        if (!this.isEditing){
          this._submit(event);
        }
        else{
          this._editText(event);
        }
        this._editFinish();
        event.preventDefault()
      }
      else if (event.keyCode === 27) {
        this._editFinish();
        event.preventDefault();
      }

      setTimeout(() => {
        if (value != '' && value != null && value != undefined) {
          window.EventBus.$emit('ON_TYPE', this.$store.state.fluxoToken, this.$store.state.respostaName, value);
        }
      }, 100)

      this.$emit('onType')
    },
    focusUserInput() {
      this.$nextTick(() => {
        this.$refs.userInput.focus();
        window.EventBus.$emit('ON_FOCUS', this.$store.state.fluxoToken, this.$store.state.respostaName);
      })
    },
    _submitSuggestion(suggestion) {
      this.onSubmit({author: 'me', type: 'text', data: { text: suggestion }})
    },
    _submit (event) {
      const text = this.$refs.userInput?.value
      const file = this.file
      if (file) {
        this._submitTextWhenFile(event, text, file)
      } else if (text && text.length > 0) {
        this._submitText(text);
      }
    },
    _submitText (text, hideMessage = false) {
      this.onSubmit({
        author: 'me',
        type: 'text',
        hideMessage,
        editarFluxoInteracaoToken: this.$store.state.editarFluxoInteracaoToken,
        data: { text }
      });
      this.$refs.userInput.value = ''
    },
    _submitTextWhenFile(event, text, file) {
      if (text && text.length > 0) {
        this.onSubmit({
          author: 'me',
          type: 'file',
          data: { text, file }
        })
        this.file = null
        this.$refs.userInput.value = ''
      } else {
        this.onSubmit({
          author: 'me',
          type: 'file',
          data: { file }
        })
        this.file = null
      }
    },
    _editText () {
      const text = this.$refs.userInput?.value;
      if (text && text.length) {
        this.$emit('edit', {
          author: 'me',
          type: 'text',
          id: store.editMessage.id,
          data: { text }
        });
        this._editFinish();
      }
    },
    _handleEmojiPicked (emoji) {
      this.onSubmit({
        author: 'me',
        type: 'emoji',
        data: { emoji }
      })
    },
    _handleFileSubmit (file) {
      this.file = file
    },
    _editFinish(){
      this.store.editMessage = null;
    }
  }
}
</script>

<style lang="scss" scoped>
.form-sender-container {
  display: flex;
  justify-content: center;
  margin-bottom: 2px;
}

.sc-user-input {
  display: flex;
  position: relative;
  width: 90%;
  margin: 0px;
  bottom: 0;
  border: 1px solid #ccc;
  border-radius: 20px;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
}

.form-sender-container.fullscreen .sc-user-input {
  max-width: 800px;
}

.sc-user-input--text {
  background: transparent;
  flex-grow: 1;
  resize: none;
  border: none;
  outline: none;
  box-sizing: border-box;
  padding: 10px 0 10px 15px;
  font-size: 0.9rem;
  font-weight: 500;
  line-height: 1.33;
  white-space: pre-wrap;
  word-wrap: break-word;
  -webkit-font-smoothing: antialiased;
  max-height: 200px;
  overflow: scroll;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

::-webkit-input-placeholder { /* WebKit, Blink, Edge */
  color: #fff;
  opacity: .6;
}
:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  color: #fff;
  opacity: .6;
}
::-moz-placeholder { /* Mozilla Firefox 19+ */
  color: #fff;
  opacity: .6;
}
:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: #fff;
  opacity: .6;
}
::-ms-input-placeholder { /* Microsoft Edge */
  color: #fff;
  opacity: .6;
}
::placeholder { /* Most modern browsers support this now. */
  opacity: .6;
}

.sc-user-input--text:empty:before {
  content: attr(placeholder);
  display: block; /* For Firefox */
  filter: contrast(15%);
  outline: none;
  cursor: text;
}

.sc-user-input--buttons {
  height: 100%;
  display: flex;
  justify-content: flex-end;
}

.sc-user-input--button {
  width: 35px;
  height: 35px;
  padding: 5px;
  display: flex;
}

.sc-user-input.active {
  box-shadow: none;
  background-color: white;
  box-shadow: 0px -5px 20px 0px rgba(150, 165, 190, 0.2);
}

.sc-user-input--button label {
  position: relative;
  height: 24px;
  padding-left: 3px;
  cursor: pointer;
}

.sc-user-input--button label:hover path {
  fill: rgba(86, 88, 103, 1);
}

.sc-user-input--button input {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 99999;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  overflow: hidden;
}

.file-container {
  background-color: #f4f7f9;
  border-top-left-radius: 10px;
  padding: 5px 20px;
  color: #565867;
}

.delete-file-message {
  font-style: normal;
  float: right;
  cursor: pointer;
  color: #c8cad0;
}

.delete-file-message:hover {
  color: #5d5e6d;
}

.icon-file-message {
  margin-right: 5px;
}
</style>
